module.exports = __webpack_public_path__ + "img/制御工学7_7.60136af8.png";